import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    .previous_page {
      border: none;
      background: transparent;
      display: flex;
      align-items: center;
      color: #9e9e9e;
      gap: 4px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
      padding: 0;
      cursor: pointer;
    }

    .previous_page:hover {
      color: #329bfc;
    }

    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    p {
      margin-top: 4px;
      color: #6b7280;
      font-size: 14px;
    }
  }
`;

export const StepCard = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 240px;

  h3 {
    font-family: Sora, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #101d40;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;

    label {
      font-size: 13px;
      font-weight: 600;
      color: #374151;
    }

    input,
    select {
      height: 40px;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 0 12px;
      font-size: 14px;
    }
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;

  .item {
    display: flex;
    flex-direction: column;
    gap: 2px;

    span.label {
      font-size: 12px;
      color: #6b7280;
    }

    span.value {
      font-size: 14px;
      color: #101d40;
      font-weight: 500;
    }
  }
`;

export const StatusBadge = styled.span<{ tone?: 'ok' | 'warn' | 'error' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  color: ${({ tone }) =>
    tone === 'ok' ? '#065f46' : tone === 'error' ? '#991b1b' : '#92400e'};
  background: ${({ tone }) =>
    tone === 'ok' ? '#d1fae5' : tone === 'error' ? '#fee2e2' : '#fef3c7'};
`;

/**
 * Área de desligamento da emissão (ação destrutiva) — separada do fluxo de
 * ativação por uma borda vermelha, com a confirmação em dois passos dentro dela.
 */
export const DangerZone = styled.div`
  margin-top: 8px;
  padding: 16px;
  border: 1px solid #fecaca;
  border-radius: 6px;
  background: #fef2f2;
  display: flex;
  flex-direction: column;
  gap: 12px;

  strong {
    font-size: 14px;
    color: #991b1b;
  }

  p {
    font-size: 13px;
    color: #7f1d1d;
  }

  .confirm_actions {
    display: flex;
    gap: 8px;
  }
`;

export const Warning = styled.div`
  background: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 12px 16px;
  color: #92400e;
  font-size: 14px;

  ul {
    margin: 8px 0 0 18px;
  }
`;

/** Ações lado a lado dentro de um passo (ex.: salvar CSC x configurar depois). */
export const InlineActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;

  /* Botão solitário (emissão já ativa) encosta à direita, onde ficava a ação
     principal do wizard. */
  > .only {
    margin-left: auto;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'ghost' | 'danger' }>`
  height: 42px;
  padding: 0 24px;
  border-radius: 6px;
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: ${({ variant }) =>
    variant === 'ghost' ? '1px solid #d1d5db' : 'none'};
  background: ${({ variant }) => {
    if (variant === 'ghost') return 'transparent';
    if (variant === 'danger') return '#dc2626';
    return '#2563eb';
  }};
  color: ${({ variant }) => (variant === 'ghost' ? '#374151' : '#fff')};

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
